/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import { Row, Col,  Table, message, Breadcrumb, Space, Modal, Tooltip, Form, Input, Tabs, Empty, Button, DatePicker, Tag, Select, Spin} from 'antd';
import { Content } from 'antd/es/layout/layout';
import axios from 'axios';
import englan from '../../english.json';
import germanlan from '../../german.json';
import arabiclan from '../../arabic.json';
import frenchlan from '../../french.json';
import hindilan from '../../hindi.json';
import malayalamlan from '../../malayalam.json';
import { useAuth } from '../Context';
import { useEffect, useReducer, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {  HistoryOutlined, DownloadOutlined, EditOutlined, HomeOutlined, PlusOutlined, SnippetsOutlined, DeleteOutlined} from '@ant-design/icons';
import chaingeFilterReducer from './reducer';
import {  ADD_ASSET_MAINTENANCE_DETAILS, ADD_ASSET_MAINTENANCE_DETAILS_ERROR, ADD_ASSET_MAINTENANCE_DETAILS_SUCCESS, ASSET_REPORT_DETAILS, ASSET_REPORT_DETAILS_ERROR, ASSET_REPORT_DETAILS_SUCCESS, ASSET_REPORT_MAINTENANCE_LIST, ASSET_REPORT_MAINTENANCE_LIST_ERROR, ASSET_REPORT_MAINTENANCE_LIST_SUCCESS, DELETE_ASSET_MAINTENANCE, DELETE_ASSET_MAINTENANCE_ERROR, DELETE_ASSET_MAINTENANCE_SUCCESS, MAINTENANCE_HISTORY_UPDATE, MAINTENANCE_HISTORY_UPDATE_ERROR, MAINTENANCE_HISTORY_UPDATE_SUCCESS } from './constants';
import { useFormik } from 'formik';
import TabPane from 'antd/es/tabs/TabPane';
import dayjs from 'dayjs';
import moment from 'moment';
import { Option } from 'antd/es/mentions';
import { Typography } from 'antd';
import {BatchDownloader} from './downloader';
const { Title } = Typography;


export default function MaintenanceHistory() {
	
	const location = useLocation();

	const {assetId} = location.state;

	const [openEditDrawer, setOpenEditDrawer] = useState(false);
	const navigate = useNavigate();

	const initalState = {assets_history:[], details: null, loading: false, error: false ,pagination: { total: 0, limit: 10, skip: 0, current:1 } };
	const [asset, dispatch] = useReducer(chaingeFilterReducer, initalState);
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`)) : null;
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));

	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const settingsdateformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'undefined' ? envdateformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`);
	const [showMaintenanceModal, setShowMaintenanceModal] = useState(false);
	const [openAttachmentModal,setShowAttachmentsModal] = useState(false);
	const envdateformat = process.env.REACT_APP_DATE_FORMAT == undefined || process.env.REACT_APP_DATE_FORMAT == 'undefined' ? 'YYYY-MM-DD' : process.env.REACT_APP_DATE_FORMAT;
	const envtimeformat = process.env.REACT_APP_TIME_FORMAT == undefined || process.env.REACT_APP_TIME_FORMAT == 'undefined' ? 'HH:mm' : process.env.REACT_APP_TIME_FORMAT;
	const { RangePicker } = DatePicker;
	const [showFetchAndDownloadModal, setShowFetchAndDownloadModal] = useState(false);
	const [url, setURL] = useState(null);
	const [images , setImages] = useState([]);
	const [showDeleteMaintenanceModal, setShowDeleteMaintenanceModal] = useState(false);
	const settingstimeformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'undefined' ? envtimeformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`);
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const customstart = localStorage.getItem(`${dashboardtype.toUpperCase()}_START_TIME`);
	const customend = localStorage.getItem(`${dashboardtype.toUpperCase()}_END_TIME`);
	const [startDate, setStartDate] = useState(customstart ? moment(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30), 'YYYY-MM-DD HH:mm:ss').set({ hour: moment(customstart, 'HH:mm:ss').hour(), minute: moment(customstart, 'HH:mm:ss').minute(),second: moment(customstart, 'HH:mm:ss').second(), millisecond: 0}) : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30));
	const [endDate, setEndDate] = useState(customend ? moment(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()), 'YYYY-MM-DD HH:mm:ss').set({ hour: moment(customend, 'HH:mm').hour(), minute: moment(customend, 'HH:mm').minute(),second: moment(customend, 'HH:mm:ss').second(), millisecond: 59}) : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()));

	let image_attachements = [];

	asset?.details?.attachmentUrls.map((item)=>{
		const lower = item.toLowerCase().trim();
		if (lower.endsWith('.jpeg') || lower.endsWith('.jpg') || lower.endsWith('.png') || lower.endsWith('.svg') || lower.endsWith(' ')) {
			image_attachements.push(item);
		}else{
			image_attachements.push(item);
		}

	});
	// const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	useAuth();
	
	useEffect(() => {
		if(featuresModule.chainageFilterEnabled == false) {
			navigate('/dashboard');
		}
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 4011);
	}, []);
	
	
	useEffect(() => {
		if(!authtoken){
			navigate('/');
		}
		loadAssetReportHistory(1);
		
	},[authtoken ,startDate , endDate]);
	useEffect(() => {

		loadAssetReportHistory(1);
		
	}, [startDate , endDate]);

	const showEditDrawer = () => {
		setOpenEditDrawer(true);
		
	};

	const onCloseEditDrawer = () => {
		setOpenEditDrawer(false);
		setImages([]);
	};

	const disabledDate = (current) => {
		// Can not select days before today and today
		return current && current > dayjs().endOf('day');
	};
	

	const loadAssetReportHistory = (pagination) => {
		let _pagination = { };
		_pagination.total = asset.pagination.total ? asset.pagination.total : 0;
		_pagination.limit = pagination.pageSize ? pagination.pageSize : 10;
		_pagination.skip =  pagination.current    ? parseInt((pagination.current-1) * pagination.pageSize) : 0;
		_pagination.pageSize =  pagination.pageSize ? pagination.pageSize : 10;
		
		
		dispatch({ type : ASSET_REPORT_MAINTENANCE_LIST});

		setURL({base: `${api}/assetsmaintenance`,params:`pipelineId=${pipelineId}&assetsId=${assetId}&maintenanceDatetime[$gte]=${moment.utc(startDate).format('YYYY-MM-DD HH:mm:ss')}&maintenanceDatetime[$lte]=${moment.utc(endDate).format('YYYY-MM-DD HH:mm:ss')}`});
	
			
		
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/assetsmaintenance?pipelineId=${pipelineId}&assetsId=${assetId}&$sort[id]=-1&$limit=${_pagination.limit}&$skip=${_pagination.skip}&maintenanceDatetime[$gte]=${moment.utc(startDate).format('YYYY-MM-DD HH:mm:ss')}&maintenanceDatetime[$lte]=${moment.utc(endDate).format('YYYY-MM-DD HH:mm:ss')}`,
			timeout: timeout,
			headers: { 
				'Authorization': `Bearer ${authtoken}`
			}
		};
	
		axios.request(config)
			.then((response) => {				
					
				if ( response.status === 200) { 
					dispatch({ type : ASSET_REPORT_MAINTENANCE_LIST_SUCCESS, payload : response.data.data , total:response.data.total , limit : response.data.limit , skip : response.data.skip , page : pagination.current, pageSize : pagination.pageSize});
					
				} else { 
					// dispatch({ type : LOG_LIST_ERROR });
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : ASSET_REPORT_MAINTENANCE_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};
	
	const openDeleteAssetsModal = () => {
		// setShowDeleteGeofenceManagementModal(true);
		setShowDeleteMaintenanceModal(true);
	};
	
	const closeDeleteMaintenanceModal = () => {
		setShowDeleteMaintenanceModal(false);
	};
		
		
	
	const columns = [
		{
			title : langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex : 'name',
			key : 'name'
		},
		
		
		{
			title : langdata && langdata.MaintenanceTime ? langdata.MaintenanceTime :  'Maintenance Time',
			dataIndex : 'maintenanceDatetime',
			key : 'maintenanceDatetime'
		},
		{
			title: `${langdata&&langdata.Status?langdata.Status:'Status'}`,
			dataIndex: 'status',
			key: 'status',

			render: (_, { status }) => (
				<>
					<Tag
						color={
							status === 'In Use'
								? 'green'
								: status === 'Maintenance'
									? 'yellow'
									: status === 'Damaged'
										? 'red'
										: 'default'
						}
					>
						{status}
					</Tag>
				</>
			),
		},
		{
			title : langdata && langdata.Remarks ? langdata.Remarks : 'Remarks',
			dataIndex : 'remarks',
			key : 'remarks',
			render:(_,record)=>{
				return record.remarks ? record.remarks : 'No Data';
			}
		},
		
		{
			title: `${langdata && langdata.Actions ? langdata.Actions:'Actions'}`,
			key: 'attachmentUrls',
			align:'center',
			render: (_,record) => (
		
				<>
					<Space style={{justifyContent:'center',display:'flex'}} size="middle">
						<a title={langdata && langdata.SHOWATTACHMENTS ? langdata.SHOWATTACHMENTS:'SHOW ATTACHMENTS'} disabled={record.attachmentUrls.length <=0} onClick={record.attachmentUrls.length > 0 ? openShowAttachments : null}><SnippetsOutlined/></a>
						<a title={langdata && langdata.Edit ? langdata.Edit:'Edit'}  onClick={showEditDrawer}><EditOutlined/></a>
						<a title={langdata && langdata.Delete ? langdata.Delete :'Delete'} onClick={openDeleteAssetsModal}><DeleteOutlined /></a>
						
					</Space>
				</>
			)
		}
		
				
			
	];
	const closeShowAttachments = () => {
		setShowAttachmentsModal(false);
		setImages([]);
	};

	const openShowAttachments = () => {
		setShowAttachmentsModal(true);

	};

	const closeMaintenanceModal = () => {
		setShowMaintenanceModal(false);
		setImages([]);
	};

	const openMaintenanceModal = () => {
		setImages([]);
		setShowMaintenanceModal(true);
	};


	const addAssetMaintenance = useFormik({
		initialValues: {
			name: '',
			status: '',
			remarks: '',
			maintenanceDateTime : new Date().toISOString,

		},
		onSubmit: (values) => {
			if (!values.name || values.name == null || values.name === '') {
				Modal.warning({ title: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name.' });
				return false;
			}
			if (!values.remarks || values.remarks == null || values.remarks === '') {
				Modal.warning({ title: langdata && langdata.Pleaseenteryourremarks ? langdata.Pleaseenteryourremarks : 'Please Enter Your Remarks' });
				return false;
			}
			if (!values.status || values.status == null || values.status === '' || values.status === 0 ) {
				Modal.warning({ title: langdata && langdata.PleaseEnterTheStatus ? langdata.PleaseEnterTheStatus : 'Please enter the status' });
				return false;
			}
			if (!values.maintenanceDateTime || values.maintenanceDateTime == null || values.maintenanceDateTime === '' || values.maintenanceDateTime === 0 ) {
				Modal.warning({ title: langdata && langdata.PleaseEnterTheChainage ? langdata.PleaseEnterTheChainage : 'Please enter the chainage' });
				return false;
			}

			
			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/assetsmaintenance`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					assetsId : assetId,
					name : values.name,
					status : values.status,
					remarks : values.remarks,
					maintenanceDatetime : values.maintenanceDateTime ,
					pipelineId :   pipelineId,
					attachmentUrls : values.attachmentUrls 
				}
			};
	
			dispatch( { type: ADD_ASSET_MAINTENANCE_DETAILS });
	
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: ADD_ASSET_MAINTENANCE_DETAILS_SUCCESS , payload: response});
						Modal.success({ title: langdata && langdata.MaintenanceAddedSuccessfully ? langdata.MaintenanceAddedSuccessfully : 'Maintenance Added Successfully' });
						addAssetMaintenance.resetForm();
						setImages([]);
						loadAssetReportHistory(1);
						closeMaintenanceModal();
					} else {
						dispatch({type: ADD_ASSET_MAINTENANCE_DETAILS_ERROR});
						Modal.warning({ title: langdata && langdata.Unabletosavethespeedclassification ? langdata.Unabletosavethespeedclassification : 'Unable to save the speed classification.' });  
					}
				})
				.catch((error) => {
					dispatch({type: ADD_ASSET_MAINTENANCE_DETAILS_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	});


	const dateHandler = (date) => {
		

		const isodate = date && date.$d.toISOString();
		addAssetMaintenance.setFieldValue('maintenanceDateTime', isodate);
	};

	const maintenanceDateHandler = (date) =>{
		const isodate = date && date.$d.toISOString();
		
		formik.setFieldValue('updatemaintenanceTime', isodate);
	};
	
	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  asset?.details?.name || '',
			remarks: asset?.details?.remarks || '',
			status: asset?.details?.status || 'In Use',
			// pipelineChainageId : asset?.details?.pipelineChainageId ?? 0,
			updatemaintenanceTime : asset?.details?.UTCmaintenance || ''

		},
		onSubmit: (values) => {
			
	
			dispatch({type:MAINTENANCE_HISTORY_UPDATE});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/assetsmaintenance/${asset.details.id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					name : values.name,
					remarks : values.remarks,
					status: values.status,
					pipelineId : parseInt(pipelineId),
					assetsId : assetId,
					maintenanceDatetime : values.updatemaintenanceTime,
					attachmentUrls : values.attachmentUrls 
					// pipelineChainageId : Number(values.pipelineChainageId) 
				}
			};
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200) {
						dispatch( { type: MAINTENANCE_HISTORY_UPDATE_SUCCESS, payload: response.data.data });
						Modal.success({ title: `${langdata && langdata.MaintenanceUpdatedSuccessfully ? langdata.MaintenanceUpdatedSuccessfully :'Maintenance updated successfully'}` });
						loadAssetReportHistory(1);
						setImages([]);
						setOpenEditDrawer(false);
						// navigate('/dashboard');
						// success('Login success')
					}
				})
				.catch((error) => {
					console.log(error);
					
					dispatch({ type: MAINTENANCE_HISTORY_UPDATE_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}	  
	});


	const loadMaintenanceDetails = ((record) => {
		
		dispatch( { type: ASSET_REPORT_DETAILS });
			
		if (!record) {
			dispatch({ type: ASSET_REPORT_DETAILS_ERROR });
		} else {
			dispatch({ type: ASSET_REPORT_DETAILS_SUCCESS, payload: record });
		
		}
		
	});
	const openShowFetchAndDownloadModal = () => {
		setShowFetchAndDownloadModal(true);
	};

	const closeShowFetchAndDownloadModal = () => {
		setShowFetchAndDownloadModal(false);
	};

	const onChangeImage = (event,options) => {
		const file = event.target.files[0];
		const formData = new FormData();
		formData.append('file',file && file ? file : '');
		
		
		let config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: `${api}/fileattachment`,
			timeout: timeout,
			headers: { 
				// 'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : formData
		};
			
		axios.request(config)
			.then((response) => {
				if (response.status === 201) {
					// console.log('response file url edit', response.data.fileUrl);
					imageHandler(response.data.fileUrl,options);
					Modal.success({ title: `${langdata && langdata.Fileuploadedsuccessfully ? langdata.Fileuploadedsuccessfully :'File uploaded successfully'}` });
					// dispatch({ type : ACKNOWLEGEMENT_ALARM_FILE_UPLOAD_SUCCESS, payload : response.data});
					// data = response.data
				}else {
					// dispatch({ type : ACKNOWLEGEMENT_ALARM_FILE_UPLOAD_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
				// dispatch({ type : ACKNOWLEGEMENT_ALARM_FILE_UPLOAD_ERROR});
			});
		
	
	};
		
	function imageHandler(val,options){
		if(options==='add'){
			const newImages = [...images, val];
			setImages(newImages);
			addAssetMaintenance.setFieldValue('attachmentUrls',newImages);
		}else if(options==='edit'){
			const newImages = [...images, val];
			setImages(newImages);
			formik.setFieldValue('attachmentUrls',newImages);
		}
			
	} 
			

	function editImageHandler(record){
		setImages(record.attachmentUrls);
	}
		
	const deleteMaintenanceHistory = () => {
		const id = parseInt(asset.details.id);
			
		dispatch({ type: DELETE_ASSET_MAINTENANCE});
		
		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/assetsmaintenance/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
		
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_ASSET_MAINTENANCE_SUCCESS, payload: response});
					setShowDeleteMaintenanceModal(false);   
					loadAssetReportHistory(1);       
				} else {
					dispatch({type:DELETE_ASSET_MAINTENANCE_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_ASSET_MAINTENANCE_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};


	const onRangeChange = (dates) => {
		if (dates) {
			if(settingstimeformat.includes(':ss')){
				const isoStartDate = dates && dates[0].$d;
				const isoEndDate = dates && dates[1].$d;
				setStartDate(isoStartDate);
				setEndDate(isoEndDate);
	
			}else{
					
				const isoStartDate = moment.utc(dates && dates[0].$d).second(0);
				const isoEndDate = moment.utc(dates && dates[1].$d).second(59);
				setStartDate(isoStartDate);
				setEndDate(isoEndDate);
	
			}
		} else {
			console.log('Clear');
		}
	};

	const getDateWithTime = (date, time) => {
		if (!time) return date;
		const [hour, minute, second] = time.split(':').map(Number);
		return dayjs(date)
			.set('hour', hour)
			.set('minute', minute)
			.set('second', second);
	};
	
	return (
		<>
			<Content>
				<Row 
					style={{
						
						paddingLeft: '10px',
						paddingRight: '10px',
						alignItems:'center',
						
					}}
      
				>
					<Col span={12}>
					
						<Breadcrumb
							style={{margin:'5px'}}
							items={[
								{
									href: '/dashboard',
									title: <HomeOutlined />,
								},
								{
									title:  <a onClick={()=>{navigate(-1);}}>{langdata && langdata.AssetReport ? langdata.AssetReport:'Asset Report'}</a> 
								},
								{
									title: `${langdata && langdata.MaintenanceHistory ? langdata.MaintenanceHistory:'Maintenance History'}`,
								},
							]}
						/>
						
					</Col>
					<Col span={24}>
						<Row
							style={{
								marginY: '10px',
								paddingLeft: '10px',
								paddingRight: '10px',
								background: '#FFFFFF',
								alignItems:'center',
							}}
						>
							<Col span={10}>
								<Row>
									<Space>
										<HistoryOutlined style={{fontSize:'30px'}}/>
									</Space>
									<Space>&nbsp;&nbsp;</Space>
									<Title level={4} style={{ paddingTop:'10px'}}> {langdata && langdata.MaintenanceHistory ? langdata.MaintenanceHistory : 'Maintenance History'}</Title>
								</Row>
							</Col>
						
							<Col   
								style ={{justifyContent:'right', display:'flex'}} span={14} >
								<Space>
									<Tooltip
										title={
											moment(startDate).format(settingsdateformat) + ' - ' +moment(endDate).format(settingsdateformat)
										}
										placement="bottom"
									>
										<RangePicker
											// style={{ width: '220px', margin: '5px' }}
											onChange={onRangeChange}
											showTime
											allowClear={false}
											// format={settingsdateformat}
											format={`${settingsdateformat} ${settingstimeformat}`}
											defaultValue={[
												getDateWithTime(dayjs().subtract(30, 'day'), customstart),
												getDateWithTime(dayjs(), customend)
											]}
											disabledDate={disabledDate}
										/>
									</Tooltip>

									{permission === 'superadmin' || permission === 'admin' ? (
										<Tooltip placement="bottom" title={langdata && langdata.Add ? langdata.Add : 'Add'}>
											<Button
												onClick={openMaintenanceModal}
												type="primary"
												style={{ margin: '5px' }}
											>
												<PlusOutlined />
												{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}
											</Button>
										</Tooltip>
									) : null}
								</Space>
							</Col>
						</Row>
					</Col>
							
					
					
					
				</Row>
				<Row style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						{ asset && asset.assets_history && asset.assets_history.length > 0 ? (
							
							<Table 
								scroll={{
									x: 900,
								}}
								columns={columns}  dataSource={asset.assets_history}  pagination = { asset.assets_history.length > 0 ? asset.pagination : 0 } onChange={loadAssetReportHistory}
								onRow = {(record) => {
									return {
										onClick: () => { 
											loadMaintenanceDetails(record);
											editImageHandler(record);
										}
									};
								}}/>
						)
							:
							(
								<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
							)}
						
					</Col>
					
				</Row>
				<Row gutter={{
					xs: 8,
					sm: 16,
					md: 24,
					lg: 32,
				}}
				style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center',
					justifyContent:'center',
					display:'flex'
				}} 
				>
					<Col style={{
						alignItems:'left',
						justifyContent:'left',
						display:'flex',
						padding:'10px'
					}}  className="gutter-row" span={24}>
						<Button disabled={asset && asset.assets_history.length > 0 ? false : true} type="primary" title={langdata && langdata.DownloadReport ? langdata.DownloadReport:'Download Report'} onClick={openShowFetchAndDownloadModal}><DownloadOutlined />{langdata && langdata.Download ? langdata.Download:'Download'}</Button>
					</Col>
				
				</Row>
				<Spin fullscreen spinning={asset.loading} />
			</Content>

			<Modal
				title={langdata && langdata.Attachments ? langdata.Attachments:'Attachments'}
				centered
				destroyOnClose={true}
				open={openAttachmentModal}
				onOk={{closeShowAttachments}}
				onCancel={closeShowAttachments}
				footer={[
				]}
				width={540}>
				<div  style={{ paddingTop: '20px',height:'400px',overflowY:'scroll' }}>

					<>
						<Tabs defaultActiveKey='1' style={{marginBottom:'10px'}}>
							<TabPane tab='Image' key='1'  >

								{image_attachements && image_attachements.length>0 ?

									image_attachements.map((item,index)=>(

										<div key={index}>
											<img  style={{width:'100%', height:'360px'}} src={item.trim()} alt='image' />

											<a target="_blank" href={item.trim()} onClick={() => {
												// handleDownload(item.trim());
											}} rel="noreferrer" >
												<br/> 
												<DownloadOutlined style={{fontSize:'20px',marginTop:'5px',marginBottom:'20px'}}/> {langdata && langdata.Downloadfile ? langdata.Downloadfile:'Download file'}</a>
																
										</div>
									)):
									<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
								}

							</TabPane>


								
																					
								
						</Tabs>
					</>
				</div>
			</Modal> 
			{/* Add maintenance history */}
			<Modal
				title={ langdata&&langdata.AddMaintenanceHistory ? langdata.AddMaintenanceHistory : 'Add Maintenance History' }
				centered
				destroyOnClose={true}
				maskClosable={false}
				open={showMaintenanceModal}
				onOk={{closeMaintenanceModal}}
				onCancel={closeMaintenanceModal}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={closeMaintenanceModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
						{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={addAssetMaintenance.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
					</Space>
				]}
				width={800}
			>
				<Form layout="vertical" onSubmit={addAssetMaintenance.handleSubmit}>
					
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="name" label={langdata&&langdata.Name?langdata.Name:'Name'} rules={[{ required: true, message: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }]} >
								<Input name="name" onChange={addAssetMaintenance.handleChange} placeholder={langdata&&langdata.PleaseEnterName?langdata.PleaseEnterName:'Please Enter Name'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="remarks" label={ langdata&&langdata.Remarks?langdata.Remarks:'Remarks'} rules={[{ required: true, message: langdata && langdata.PleaseEnterRemark ? langdata.PleaseEnterRemark : 'Please Enter Remark' }]} >
								<Input name="remarks" onChange={addAssetMaintenance.handleChange} placeholder={langdata&&langdata.PleaseEnterRemark?langdata.PleaseEnterRemark:'Please enter the remark'} />
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item
								label={langdata?.Status || 'Status'}
								name="status"
								rules={[{ required: true, message: 'Please select a status' }]}
							>
								<Select
									onChange={(value) => addAssetMaintenance.setFieldValue('status', value)}
									placeholder={langdata?.SelectStatus || 'Select Status'}
								>
									<Option value={langdata?.InUse || 'In Use'}>{langdata?.InUse || 'In Use'}</Option>
									<Option value={langdata?.Maintenance || 'Maintenance'}>{langdata?.Maintenance || 'Maintenance'}</Option>
									<Option value={langdata?.Damaged || 'Damaged'}>{langdata?.Damaged || 'Damaged'}</Option>
								</Select>
							</Form.Item>

						</Col>
					</Row> 
					
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.MaintenanceTime ? langdata.MaintenanceTime : 'Maintenance Time'}   >
									
								<DatePicker name="maintenanceDateTime" style={{ width: '100%'}} allowClear={false}  
									placeholder={langdata && langdata.PleaseEnterTheDate ? langdata.PleaseEnterTheDate : 'Please enter the date'}
									onChange={(date)=>{ dateHandler (date, 'end');}} format = {settingsdateformat  + ' ' + settingstimeformat} showTime disabledDate={(current) => {
										// Disable future dates
										return current && current > dayjs().endOf('day');
									}}/>
							</Form.Item>
						</Col>
					</Row>

					<Row
						gutter={24}
					>			
						<Col  span={24}>  
							
							<Form.Item
								label={langdata && langdata.Attachments ? langdata.Attachments : 'Attachments'}
								name="Image"
								rules={[{ required: false }]}>
								<Button >
																
									<input onChange={(value)=>{onChangeImage(value,'add');}} id='fileUpload' type='file' multiple  
										accept="image/*"
									/>
								</Button>
							</Form.Item>
						</Col>
					</Row>
					
														
				</Form>
			</Modal>
			{/* Fetch and Download Modal Starts */}
			<Modal
				title={langdata && langdata.DownloadReport ? langdata.DownloadReport:'Download Report'}
				centered
				destroyOnClose={true}
				open={showFetchAndDownloadModal}
				onOk={{closeShowFetchAndDownloadModal}}
				onCancel={closeShowFetchAndDownloadModal}
				footer={[
								
				]}
				width={540}
			>
				<Row gutter={16}>
					<Col span={24}>
						<Typography>
							{langdata && langdata.Totalnumberofrecords ? langdata.Totalnumberofrecords:'Total number of records'} : {asset.pagination.total}
						</Typography>
					</Col>
				</Row>
			
				{asset.pagination && asset.pagination.total> 0 ? (
					<BatchDownloader total={asset.pagination && asset.pagination.total} url={url}/>
				) : (
					<>
						<Row gutter={16} style={{
							backgroundColor: '#d3d3d3',
							padding: '5px',
							marginTop: '10px'
						}}>
							<Col span={24}>
								<Typography>{langdata && langdata.Norecordsfound ? langdata.Norecordsfound:'No records found.'}</Typography>
							</Col>
						</Row>
						<br/>
					</>
				
				)}
			</Modal>
			{/* Fetch and Download Modal Modal Ends */}

			{/* {Edit asset modal} */}
			<Modal
				title={langdata && langdata.EditAssetDetails ? langdata.EditAssetDetails:'Edit Asset Details'}
				width={800}	
				centered
				destroyOnClose={true}
				maskClosable={false}
				onOk={formik.handleSubmit}
				onCancel={onCloseEditDrawer}
				open={openEditDrawer}
				styles={{
					body: {
					},
				}}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={onCloseEditDrawer}>
							{langdata && langdata.CANCEL ? langdata.CANCEL:'CANCEL'}
						</Button>
						<Button onClick={formik.handleSubmit} type="primary">
							{langdata && langdata.SAVE ? langdata.SAVE:'SAVE'}
						</Button>
					</Space>
				]}
			>
				<Form onSubmit={formik.handleSubmit} layout="vertical">
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.AssetName ? langdata.AssetName:'Asset Name'} rules={[{ required: false, message: `${langdata && langdata.Name ? langdata.Name:'Name'}` }]}>
								<Input name="name" value={formik.values.name} onChange={formik.handleChange}   placeholder={langdata && langdata.Name ? langdata.Name:'Name'} />
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="updatemaintenanceTime"label={langdata && langdata.MaintenanceTime ? langdata.MaintenanceTime : 'MaintenanceTime'}   >
									
								<DatePicker  style={{ width: '100%'}} allowClear={false}  
									value={formik.values.updatemaintenanceTime}
									placeholder={langdata && langdata.PleaseEnterEndDate ? langdata.PleaseEnterEndDate : 'Please enter the end date'}
									onChange={(date)=>{ maintenanceDateHandler (date);}} format = {settingsdateformat  + ' ' + settingstimeformat}
									defaultValue={dayjs(new Date(formik.values.updatemaintenanceTime))} showTime/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item
								label={langdata?.Status || 'Status'}
								name="status"
								rules={[{ required: false, message: 'Please select a status' }]}
							>
								<Select
									onChange={(value) => formik.setFieldValue('status', value)}
									placeholder={langdata?.SelectStatus || 'Select Status'}
									defaultValue={formik.values.status}
								>
									<Option value={langdata?.InUse || 'In Use'}>{langdata?.InUse || 'In Use'}</Option>
									<Option value={langdata?.Maintenance || 'Maintenance'}>{langdata?.Maintenance || 'Maintenance'}</Option>
									<Option value={langdata?.Damaged || 'Damaged'}>{langdata?.Damaged || 'Damaged'}</Option>
								</Select>
							</Form.Item>

						</Col>
					</Row> 
  
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item  label={langdata && langdata.Remarks ? langdata.Remarks:'Remarks'} rules={[{ required: false, message: `${langdata && langdata.Pleaseenteryourremarks ? langdata.Pleaseenteryourremarks:'Please enter your remarks'}` }]} >
								<Input name="remarks" value={formik.values.remarks} onChange={formik.handleChange}  placeholder={langdata && langdata.Pleaseenteryourremarks ? langdata.Pleaseenteryourremarks:'Please enter your remarks'} />
							</Form.Item>
						</Col>
					</Row>

					<Row
						gutter={24}
					>			
						<Col  span={24}>  
												
							<Form.Item
								label={'Image'}
								name="Image"
								rules={[{ required: false }]}>
								<Button >
																
									<input onChange={(value)=>{onChangeImage(value,'edit');}} id='fileUpload' type='file' multiple  
										accept="image/*"
									/>
								</Button>
							</Form.Item>
						</Col>
					</Row>

				</Form>
			</Modal>

			<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteMaintenanceModal} onOk={deleteMaintenanceHistory} onCancel={closeDeleteMaintenanceModal}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}> { langdata && langdata.Areyousureyouwanttodeletethis ? langdata.Areyousureyouwanttodeletethis : 'Are you sure you want to delete this ?' }</Col>
				</Row>
			</Modal>

			
		</>
	);
}

